import React from 'react';
import './testimonial.css';
import {TESTIMONIALS_TITLE, TESTIMONIALS_DESCRIPTION, TESTIMONIALS} from '../../constants';
import {Carousel} from 'react-responsive-carousel';
import tania from './tania.jpg';
import roman from './roman.jpg';
import tatsiana from './tatsiana.jpg';

let photos = [tania, roman, tatsiana];

const Testimonial = () => {
  return (
    <div className="testimonial">
      <h3 className="testimonial__title">{TESTIMONIALS_TITLE}</h3>
      <div className="testimonial__description">{TESTIMONIALS_DESCRIPTION}</div>
      <div className="testimonial__list">
        <Carousel
          showArrows={false}
          showThumbs={false}
          showStatus={false}
          useKeyboardArrows={true}
          swipeScrollTolerance={0}
          emulateTouch
          children={TESTIMONIALS.map((item, index) => {
            return (
              <div key={'testimonial-' + item.name} className={`testimonial__item testimonial__item--${index}`}>
                <div className="testimonial__icon">
                  <img className="testimonial__icon-img" src={photos[index]} alt={`${item.name}`}/>
                </div>
                <div className="testimonial__info">
                  <div className="testimonial__name">{item.name}</div>
                  <div className="testimonial__position">{item.position}</div>
                  <div className="testimonial__text">{item.text}</div>
                </div>
              </div>
            )
          })}>
        </Carousel>
      </div>
    </div>
  );
};

export default Testimonial;



// WEBPACK FOOTER //
// ./src/components/Testimonial/Testimonial.js